import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  TabNavigationCtrlFilterPanel: {
    margin: theme.sizes.spacing.default,
  },
  navigation: {
    display: 'flex',
    borderBottom: '2px #ccc solid',
    marginBottom: '7px',
    marginTop: theme.sizes.spacing.default,
  },
  navigationRoutes: {
    flex: 1,
  },
  navigationRoutesTabs: {
    width: '100%',
  },
  navigationRoutesTabsTab: {
    paddingTop: theme.sizes.spacing.minor,
    paddingBottom: theme.sizes.spacing.minor,
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  navigationControls: {
    textAlign: 'right',
  },
  addButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: '350px',
    height: '65px',
    width: "100%",
  },
  calledButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: '350px',
    height: '65px',
    width: "100%",
    backgroundColor: '#d57f00',
    "&:hover": {
      backgroundColor: "#b46b00",
    },
  },
  inputFilterTruckPlate: {
    backgroundColor: 'white',
    width: '100%',
    '& .MuiInputLabel-shrink': {
      color: 'white',
      transform: 'translate(14px, -16px) scale(0.75)',
    }
  },
  iconCanceled: {
    color: theme.palette.red.main,
    fontSize: '2rem'
  },
  iconCompleted: {
    color: theme.palette.success.main,
    fontSize: '2rem'
  }
}));

export default useStyles;
